export default __webpack_public_path__ + "static/media/home.c5e36c58.jpg";